import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const storesStyle = css`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: var(--space-225);
  background-color: var(--background-primary);
  border-bottom: var(--space-150);
  ${breakpoints.to.desktop} {
    display: none;
  }
  ${breakpoints.from.tablet} {
    position: absolute;
    top: var(--space-150);
    left: var(--space-150);
    width: 400px;
    height: calc(100% - 2 * var(--space-150));
    padding: var(--space-225) 0 var(--space-225) var(--space-225);
  }
  ${breakpoints.only.mobile} {
    z-index: 100;
  }
`;

export const regionChooserStyle = css`
  ${breakpoints.from.tablet} {
    margin-right: var(--space-225);
  }
`;

export const storesListContainerStyle = css`
  position: relative;
  height: 100%;
  margin-top: var(--space-200);
`;

export const storesListStyle = css`
  position: absolute;
  width: 100%;
  height: 100%;
  ${breakpoints.from.tablet} {
    width: 364px;
  }

  list-style-type: none;
  padding-inline-start: 0px;
`;
